import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Users, Target, Award, TrendingUp } from 'lucide-react';
import SEO from '../components/SEO';

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="Rólunk"
        description="Megbízható partner a pénzügyi sikerben. Több évtizedes tapasztalat a könyvelés és adótanácsadás területén."
      />
      {/* Hero */}
      <section className="relative py-20 sm:py-28 bg-[#0B1B3D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-[#C5A059] text-xs uppercase tracking-[0.2em] font-semibold">Rólunk</span>
            <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-['Outfit'] font-light text-white tracking-tight">
              Megbízható partner a <span className="font-semibold">pénzügyi sikerben</span>
            </h1>
            <p className="mt-6 text-lg text-[#94A3B8] leading-relaxed">
              Több évtizedes tapasztalattal rendelkezünk a könyvelés és adótanácsadás területén. Célunk: az ügyfelek nyugalma és pénzügyi átláthatósága.
            </p>
          </div>
        </div>
      </section>

      {/* Image + text */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1758518727600-2c5f48419eac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzc2Mjg2OTc3fDA&ixlib=rb-4.1.0&q=85"
                alt="Professzionális csapat"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>
            <div>
              <span className="text-[#C5A059] text-xs uppercase tracking-[0.2em] font-semibold">Kik vagyunk</span>
              <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-['Outfit'] font-semibold text-[#0B1B3D] tracking-tight">
                Szakértőink az Ön szolgálatában
              </h2>
              <p className="mt-6 text-base text-[#64748B] leading-relaxed">
                Az AGM Consulting csapata tapasztalt könyvelőkből, adószakértőkből és pénzügyi tanácsadókból áll. Célunk, hogy ügyfeleink a saját üzletükre fókuszálhassanak, míg mi gondoskodunk a pénzügyi háttérről.
              </p>
              <p className="mt-4 text-base text-[#64748B] leading-relaxed">
                Digitális működéssel, a Novitax rendszer alkalmazásával biztosítjuk az átlátható, naprakész és papírmentes könyvelést. Legyen szó kisvállalkozásról vagy közepes méretű cégről, mi megtaláljuk a megfelelő megoldást.
              </p>
              <div className="mt-8">
                <Link to="/kapcsolat">
                  <Button className="bg-[#0B1B3D] hover:bg-[#162B56] text-white" data-testid="about-cta-btn">
                    Kapcsolatfelvétel <ArrowRight className="ml-2" size={16} />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 sm:py-28 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-[#C5A059] text-xs uppercase tracking-[0.2em] font-semibold">Értékeink</span>
            <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-['Outfit'] font-semibold text-[#0B1B3D] tracking-tight">
              Amiben hiszünk
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Users, title: 'Ügyfeleink', desc: 'Több száz elégedett ügyfél bizalmát élvezzük Magyarország-szerte.' },
              { icon: Target, title: 'Precizitás', desc: 'Pontos, időben elkészült bevallások és kimutatások, minden esetben.' },
              { icon: Award, title: 'Minőség', desc: 'Magas színvonalú szolgáltatások, folyamatos szakmai fejlődés.' },
              { icon: TrendingUp, title: 'Növekedés', desc: 'Segítünk vállalkozása pénzügyi stabilizálásában és növekedésében.' },
            ].map(({ icon: Icon, title, desc }, i) => (
              <div key={title} className="p-8 bg-white border border-[#E2E8F0] rounded-lg hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <Icon size={28} className="text-[#C5A059] mb-4" strokeWidth={1.5} />
                <h3 className="text-lg font-['Outfit'] font-semibold text-[#0B1B3D] mb-2">{title}</h3>
                <p className="text-sm text-[#64748B] leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
